// import { useState } from "react";
import { fetchResponseAdapter } from "../../../../../adapters/fetchAdapter";
import useCallApiAndLoad from "../../../../../hooks/useCallApiAndLoad";
import { getDetailProjectUnits } from "../../../services/devsServices";
import { useDispatch, useSelector } from "react-redux";
import { useRef } from "react";
import {
    fetchDetailProjectUnitsStart,
    fetchDetailProjectUnitsSuccess,
    fetchDetailProjectUnitsError,
} from "../../../../../redux/features/detailProjectUnits";
import { unsetAuth } from "../../../../../helpers/authHelper";
import { useNavigate } from "react-router-dom";
import { AppStore } from "../../../../../redux/store";
import { logoutAction } from "../../../../../redux/features/auth";

export const useDetailProjectUnit = () => {
    const user = useSelector((store: AppStore) => store.auth);
    const token = require("../../../../../helpers/authHelper").getAuthToken(user);
    const { country } = useSelector((store: AppStore) => store.country);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const detailProjectUnitsState = useSelector((store: AppStore) => store.detailProjectUnits);
    const dataDetailUnit = detailProjectUnitsState.data;
    const detailProjectUnitLoading = detailProjectUnitsState.loading;
    const paginator = detailProjectUnitsState.paginator || {
        page: 0,
        take: 0,
        itemCount: 0,
        pageCount: 0,
        hasPreviousPage: false,
        hasNextPage: false,
    };
    const { callEndpoint } = useCallApiAndLoad();

    const prevSortRef = useRef<string | undefined>(undefined);

    const getDataDetailUnit = async (id: string, filters?: Record<string, string | number>, sort?: string, load?: boolean) => {
        if (detailProjectUnitLoading) return; // Si está cargando, no volver a consultar
        load && dispatch(fetchDetailProjectUnitsStart());

        try {
            let cleanFilters: Record<string, string | number> | undefined = {};
            if (filters) {
                cleanFilters = Object.fromEntries(
                    Object.entries(filters)
                        .filter(([key, value]) => value !== undefined && value !== null && value !== "" && value !== "0")
                );
            }

            if (sort) {
                cleanFilters['sort'] = sort === "asc" ? "unit_name" : "last_update";
            }

            // Si el sort cambió, forzar page a 1
            const prevSort = prevSortRef.current;
            if (sort !== prevSort) {
                cleanFilters['page'] = 1;
            }

            const { status, data } = await callEndpoint(getDetailProjectUnits(token, id, cleanFilters));
            if (status === 401) {
                dispatch(logoutAction({}));
                unsetAuth();
                navigate(`/app/${country}/auth/desarrolladoras/login`);
            }
            if (status === 200) {
                const response = fetchResponseAdapter(data);
                let items = response?.data?.items;
                const meta = response?.data?.meta;
                // Anidar solo si sort no cambia y page > 1
                const prevSort = prevSortRef.current;
                if (meta.page && meta.page > 1 && sort === prevSort) {
                    items = [...dataDetailUnit, ...items];
                }
                dispatch(fetchDetailProjectUnitsSuccess({ items, meta }));
                // Actualizar el prevSort para el siguiente render
                prevSortRef.current = sort;
            } else {
                dispatch(fetchDetailProjectUnitsError('Error al obtener units'));
            }
        } catch (error: any) {
            console.log(error);
            dispatch(fetchDetailProjectUnitsError(error?.message || 'Error desconocido'));
        }
    };

    return { dataDetailUnit, detailProjectUnitLoading, paginator, getDataDetailUnit };
};
